import { all, put, takeLatest } from 'redux-saga/effects';
import { BOOTSTRAP_SESSION } from '../actions/BootstrapActions';
import { SIGN_IN_SUCCESS } from '../actions/SigninActions';
import { TOKEN_ERROR } from '../actions/index';
import { defaultApi } from '../utils/axiosApi';

export function* bootstrapAttempt() {
  const token = localStorage.getItem('access_token');
  if (!token) return;

  const base = process.env.REACT_APP_API_BASE_URL;
  const me = yield defaultApi(`${base}/user/me`, 'GET', undefined, true);

  if (me.response) {
    const meData = me.response.data.data;
    if (meData.activeProfile && meData.activeProfile.id) {
      localStorage.setItem('active_company_id', meData.activeProfile.id);
    }
    yield put({
      type: SIGN_IN_SUCCESS,
      credentials: { message: '', data: { token, ...meData } },
    });
  } else if (me.error) {
    const { data } = me.error;
    if (data.status === 'Token_error') {
      yield put({ type: TOKEN_ERROR, message: data.message });
    }
  }
}

export function* bootstrap() {
  yield takeLatest(BOOTSTRAP_SESSION, bootstrapAttempt);
}

export default function* rootSaga() {
  yield all([bootstrap()]);
}
